
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/volunteer",
      function () {
        return require("private-next-pages/volunteer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/volunteer"])
      });
    }
  